export const eduInfo = {
  grade: '',
  subject: '',
  stage: ''
};
